module.exports = __webpack_public_path__ + "img/inspection.ac36bad1.png";